import { ThemeProvider } from "@mui/material/styles";

import { darkTheme } from "./base/theme";
import Main from "./pages";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { MapProvider } from "react-map-gl";
import "maplibre-gl/dist/maplibre-gl.css";

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <MapProvider>
        <Main />
      </MapProvider>
    </ThemeProvider>
  );
}

export default App;
